import React from 'react';
import { useMessages, usePaths } from "react-chatbotify";
import { FaDatabase, FaSyncAlt } from 'react-icons/fa';
import { MD_CAT_BLACK, MD_CAT_YELLOW } from '../constants';
import { setActionPayload, tableState } from '../state';

// Per-row action buttons rendered inside Gap/Partial coverage cells. Sends a crafted
// message through the normal chat flow so the bot reply streams back seamlessly.
export const CoverageActionButtons = ({ capability, coverage }: { capability: string; coverage: 'gap' | 'partial' }) => {
  const { injectMessage } = useMessages();
  const { goToPath } = usePaths();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [inputVal, setInputVal] = React.useState("");

  const sendAction = async (payload: string) => {
    setActionPayload(payload);
    await injectMessage(payload, "USER");
    await goToPath("action");
  };

  const handleCheckDatabase = () => {
    tableState.showUpdateTableButton = false;
    sendAction(`check data agent for {${capability}}`);
  };

  const handleRecheckSubmit = () => {
    const extra = inputVal.trim();
    setDialogOpen(false);
    setInputVal("");
    tableState.lastRecheckCapability = capability;
    tableState.lastRecheckApi = "";       // clear stale value from any previous recheck
    tableState.lastRecheckCoverage = ""; // clear stale value from any previous recheck
    tableState.showUpdateTableButton = true;
    sendAction(`check api agent for {${capability} ${extra ? `, ${extra}` : ""}}`);
  };

  const iconBtn: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '26px',
    height: '26px',
    borderRadius: '50%',
    cursor: 'pointer',
    padding: 0,
    fontSize: '12px',
  };

  return (
    <div className="rcb-row-actions" style={{ display: 'flex', gap: '6px', justifyContent: 'center', marginTop: '6px' }}>
      {coverage === 'gap' && (
        <button
          title="Check database via data agent"
          aria-label="Check database"
          onClick={handleCheckDatabase}
          style={{ ...iconBtn, background: '#fff', color: MD_CAT_BLACK, border: `1.5px solid ${MD_CAT_BLACK}` }}
        >
          <FaDatabase />
        </button>
      )}
      <button
        title="Recheck this capability"
        aria-label="Recheck capability"
        onClick={() => setDialogOpen(true)}
        style={{ ...iconBtn, background: MD_CAT_YELLOW, color: MD_CAT_BLACK, border: `1.5px solid ${MD_CAT_YELLOW}` }}
      >
        <FaSyncAlt />
      </button>

      {dialogOpen && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}>
          <div style={{ background: '#fff', borderRadius: '8px', padding: '24px', width: '360px', boxShadow: '0 4px 20px rgba(0,0,0,0.3)', textAlign: 'left' }}>
            <h3 style={{ margin: '0 0 6px', fontSize: '16px', color: MD_CAT_BLACK }}>Recheck capability</h3>
            <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#555' }}>{capability}</p>
            <textarea
              value={inputVal}
              onChange={(e) => setInputVal(e.target.value)}
              placeholder="Add any extra context (optional)..."
              style={{ width: '100%', height: '80px', borderRadius: '4px', border: '1px solid #ccc', padding: '8px', fontSize: '14px', resize: 'none', boxSizing: 'border-box' }}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
              <button
                onClick={() => { setDialogOpen(false); setInputVal(""); }}
                style={{ padding: '6px 16px', borderRadius: '4px', border: '1px solid #ccc', background: '#fff', cursor: 'pointer' }}
              >
                Cancel
              </button>
              <button
                onClick={handleRecheckSubmit}
                style={{ padding: '6px 16px', borderRadius: '4px', border: 'none', background: MD_CAT_YELLOW, color: '#000', fontWeight: 600, cursor: 'pointer' }}
              >
                Recheck
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
